import { motion } from "framer-motion";
import "./App.css";
import logo from "../src/chronickl.png"

export default function App() {
  return (
    <div>
      {/* Section Hero */}
      <section className="hero">
      <motion.img
          src={logo}
          alt="Logo Chronickl"
          initial={{ opacity: 0, scale: 0.5 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 1 }}
        />
        <motion.h1
          initial={{ opacity: 0, y: -50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
        >

          Chronickl SARL
        </motion.h1>
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.5, duration: 1 }}
        >
          Spécialistes en digitalisation des services et développement
          d’applications web & mobiles, basés à Libreville depuis 2020.
        </motion.p>
      </section>

      {/* Section A propos */}
      <section className="about">
        <motion.h2
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          Qui sommes-nous ?
        </motion.h2>
        <p>
          Depuis 2020, Chronickl SARL accompagne les entreprises et les
          particuliers dans leur transition digitale à Libreville et ailleurs.
          Nous développons des solutions modernes, fiables et adaptées aux
          besoins locaux.
        </p>
      </section>

      {/* Section Réalisations */}
      <section className="projects">
        <motion.h2
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          Nos Applications
        </motion.h2>

        <div className="projects-grid">
          <motion.div
            whileHover={{ scale: 1.05 }}
            className="project-card"
          >
            <h3>Okira</h3>
            <p>
              Une application dédiée à présenter la mercuriale des prix et à
              signaler les commerces qui ne la respectent pas.
            </p>
          </motion.div>

          <motion.div
            whileHover={{ scale: 1.05 }}
            className="project-card"
          >
            <h3>Agnos</h3>
            <p>
              Une application sociale permettant de lancer des appels aux dons
              et de soutenir les initiatives solidaires.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Section Contact */}
      <section className="contact">
        <motion.h2
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          Contactez-nous
        </motion.h2>
        <p>
          📍 Libreville, Gabon <br />
          📧 fidele.ndzime@chronickl.fr <br />
          Phone: +24174093850
        </p>
        
      </section>
    </div>
  );
}
